import { SvgLoaderSize } from "../loader/SvgLoader";

export class Svg extends HTMLElement {

    private _svg: SVGGraphicsElement;
    private _abort: AbortController;

    constructor() {
        super();

        this._abort = new AbortController();

        this.attachShadow({ mode: "open" });

        //create a new stylesheet from all the styles in the document
        // where the selector contains the tag name of this element
        // const style = document.createElement("style");
        // style.type = "text/css";
        // style.appendChild(document.createTextNode(""));
        // this.shadowRoot.appendChild(style);
        // const sheet = style.sheet as CSSStyleSheet;
        // // console.log(Array.from(document.styleSheets));
        // const cssRules = Array.from(document.styleSheets)
        //     // .filter(s => s.href === null)
        //     .map(s => Array.from(s.cssRules))
        //     .reduce((a, b) => a.concat(b), [])
        //     // .filter(r => r.selectorText && r.selectorText.includes("e5-svg"));
        // // for (let i = 0; i < cssRules.length; i++) {
        // //     const rule = cssRules[i];

        // //     //replace the e5-svg with :host
        // //     sheet.insertRule(rule.cssText.replace(/e5-svg/g, ":host"), sheet.cssRules.length);
        // // }
        // console.log(cssRules);

        this.shadowRoot.innerHTML = `
            <style>
                :host {
                    position: relative;
                    display: inline-block;
                    height: 1em;
                }

                svg{
                    display: block;
                    height: 100%;
                }

                :host(:not([color]))>svg *,
                :host([color=""])>svg *,
                :host([color="original"])>svg *{
                }
                
                :host([color="custom"])>svg *{
                    fill: var(--e5-svg__fill, currentColor);
                    stroke: var(--e5-svg__stroke, transparent);
                }

                :host([color="stroke"])>svg *{
                    fill: transparent;
                    stroke: var(--e5-svg__stroke, currentColor);
                }

                :host([color="fill"])>svg *{
                    fill: var(--e5-svg__fill, currentColor);
                    stroke: transparent;
                }
                
            </style>
            <slot></slot>
        `;
    }

    // :host(:not([color])) .e5-svg__wrapper>svg *{
    //     fill: var(--e5-svg__fill, currentColor) !important;
    // }

    connectedCallback() {
        // this._svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        // this._svg.setAttribute("width", "100%");
        // this._svg.setAttribute("height", "100%");
        // this._svg.setAttribute("viewBox", "0 0 100 100");
        // this.shadowRoot.appendChild(this._svg);

        this.loadSvg();
    }

    private setColor(color: string | "auto"): void {

    }

    private _loading: boolean = false;
    private async loadSvg() {

        if(this._svg){
            this._svg.remove();
            this._svg = null;
        }

        if (this._loading) {
            this._abort.abort();
        }

        this._loading = true;

        if (this.hasAttribute("src")) {
            const src = this.getAttribute("src");

            let data = "";
            try {
                const response = await fetch(src,
                    {
                        signal: this._abort.signal
                    });
                data = await response.text();
            } catch (error) {
                this._loading = false;
                return;
            }

            var parser = new DOMParser();
            var doc = parser.parseFromString(data, "image/svg+xml");
            const svg: SVGGraphicsElement = doc.documentElement as any;
            svg.querySelectorAll("*").forEach((e) => {
                if(e.id){
                    e.setAttribute("part", e.id);
                }
                // e.setAttribute("part", e.tagName.toLowerCase());
            });

            let x = 0;
            let y = 0;
            let w = 150;
            let h = 150;

            const viewBox = {
                x: 0,
                y: 0,
                width: w,
                height: h
            };
            if (svg.hasAttribute("viewBox")) {
                var values = svg.getAttribute("viewBox").split(/[\s,]+/i);
                if (values.length >= 4) {
                    viewBox.x = parseFloat(values[0]);
                    viewBox.y = parseFloat(values[1]);
                    x = viewBox.x;
                    y = viewBox.y;
                    viewBox.width = parseFloat(values[2]);
                    viewBox.height = parseFloat(values[3]);
                }
            }

            if (svg.hasAttribute("width")) {
                w = parseFloat(svg.getAttribute("width"));
            } else {
                w = viewBox.width;
            }

            if (svg.hasAttribute("height")) {
                h = parseFloat(svg.getAttribute("height"));
            } else {
                h = viewBox.height;
            }

            let size: SvgLoaderSize = "responsive";
            if (size === "responsive") {
                svg.setAttribute("viewBox", `${x} ${y} ${w} ${h}`);
                svg.removeAttribute("width");
                svg.removeAttribute("height");
            }
            else if (size === "intrinsic") {
                if (!svg.hasAttribute("width")) {
                    svg.setAttribute("width", w + "");
                }
                if (!svg.hasAttribute("height")) {
                    svg.setAttribute("height", h + "");
                }
            }

            //convert inline css styles to attributes for all elements in the svg
            const elements = svg.querySelectorAll<HTMLElement>("*");
            for (let i = 0; i < elements.length; i++) {
                const element = elements[i];
                for (let j = 0; j < element.style.length; j++) {
                    const style = element.style[j];
                    element.setAttribute(style, element.style[style as any]);
                }
                element.removeAttribute("style");
            }

            if(this._svg){
                this._svg.remove();
            }
            svg.setAttribute("part", "svg");
            this._svg = svg;
            this.shadowRoot.appendChild(svg);

            this._loading = false;
        } else {
            this._loading = false;
        }
    }
}

try {
    customElements.define("e5-svg", Svg);
} catch (error) {
    
}